import { useTranslation } from 'react-i18next';
import classes from './Steps.module.scss';
import image from '../../../assets/img/Plumbing/steps.avif';

const cards = [
    {
        subtitle: 'plumbing.steps.card_01.subtitle',
        desc: 'plumbing.steps.card_01.desc',
    },
    {
        subtitle: 'plumbing.steps.card_02.subtitle',
        desc: 'plumbing.steps.card_02.desc',
    },
    {
        subtitle: 'plumbing.steps.card_03.subtitle',
        desc: 'plumbing.steps.card_03.desc',
    },
    {
        subtitle: 'plumbing.steps.card_04.subtitle',
        desc: 'plumbing.steps.card_04.desc',
    },
    {
        subtitle: 'plumbing.steps.card_05.subtitle',
        desc: 'plumbing.steps.card_05.desc',
    },
];

const Steps = () => {
    const { t } = useTranslation();
    return (
        <section className="mt container">
            <div className={classes.wrap}>
                <div className={classes.body}>
                    <h2 className={`${classes.title} font-48`}>
                        {t('plumbing.steps.title')}
                    </h2>
                    <div className={classes.cards}>
                        {cards.map((card, index) =>
                            <div key={index} className={classes.card}>
                                <div className={classes.num}>
                                    {index + 1}
                                </div>
                                <div className={`${classes.content} font-16`}>
                                    <h4 className={classes.subtitle}>
                                        {t(card.subtitle)}
                                    </h4>
                                    <p className={classes.desc}>
                                        {t(card.desc)}
                                    </p>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                <img className={classes.image} src={image} alt='' />
            </div>
        </section>
    );
};

export default Steps;
